import type { SupabaseClient } from '../supabase/client';
import type { Store, UpdateStoreNewsletterCollectionInput } from '../types/store';
import { WEBSITE_UUID_RE } from '../lib/website-templates/internal';

export async function updateStoreNewsletterCollection(
  client: SupabaseClient,
  input: UpdateStoreNewsletterCollectionInput,
): Promise<Store> {
  if (!WEBSITE_UUID_RE.test(input.storeId) || typeof input.enabled !== 'boolean') {
    throw new Error('set_store_newsletter_collection: invalid input');
  }
  const { data, error } = await client.rpc('set_store_newsletter_collection', {
    target_store_id: input.storeId,
    enabled: input.enabled,
  });
  if (error) throw error;
  if (!data) throw new Error('set_store_newsletter_collection: empty result');
  return data as unknown as Store;
}
